import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { View } from 'react-native';

import type { Credit } from '@sg/graphql-schema';

import { CreditsListItem } from '../CreditsListItem';

// ─────────────────────────────────────────────────────────────────────────────

export const CreditsList = (props: CreditBalanceDetailsProps) => {
  const { credits, totalCreditsAmount } = props;

  const shouldRenderTotalCreditsAmount = typeof totalCreditsAmount === 'number';

  return (
    <View>
      {credits.map((credit, index) => (
        <CreditsListItem
          key={credit.id}
          title={credit.storefrontEligibilityTitle ?? credit.title}
          amount={credit.remainingAmount}
          createdAtDate={credit.createdAt}
          expirationDate={credit.expiresAt}
          creditType={credit.creditType}
          hasTopBorder={index > 0}
        />
      ))}

      {shouldRenderTotalCreditsAmount ? (
        <CreditsListTotalCreditsItem totalCreditsAmount={totalCreditsAmount} />
      ) : null}
    </View>
  );
};

// ─────────────────────────────────────────────────────────────────────────────

const CreditsListTotalCreditsItem = (props: CreditsListTotalCreditsItemProps) => {
  const { totalCreditsAmount } = props;

  const { formatMessage } = useIntl();

  return (
    <CreditsListItem
      title={formatMessage(messages.accountCreditLabel)}
      amount={totalCreditsAmount}
      hasTopBorder
      borderTopColor="DARK_KALE"
      isTitleBold
    />
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accountCreditLabel: {
    defaultMessage: 'Total credit',
    description: 'Account | Credit | Label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type CreditBalanceDetailsProps = Readonly<{
  credits: readonly Credit[];
  totalCreditsAmount?: number;
}>;

type CreditsListTotalCreditsItemProps = Readonly<{
  totalCreditsAmount: number;
}>;
